import { c as _c } from "react/compiler-runtime";
// Eslint disable required since we cannot add keydown handler to the trigger component
/* eslint-disable jsx-a11y/no-static-element-interactions */
import { UncontrolledPopper } from '@newfront-insurance/core-ui';
import { cn } from '@newfront-insurance/core-ui/v2';
import * as React from 'react';
export type QuickSelectOptions = {
  [key: string]: number;
};
interface Props {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onChange: (value: any) => void;
  triggerComponent: React.ReactNode;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  quickSelectOptions: QuickSelectOptions;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function getValueFromIndex(index: number, options: QuickSelectOptions): any {
  return options[Object.keys(options)[index]];
}
export function InputQuickSelect(props) {
  const $ = _c(17);
  const {
    onChange,
    triggerComponent,
    quickSelectOptions
  } = props;
  const [showingSuggestions, setShowingSuggestions] = React.useState(false);
  const [activeSuggestionIndex, setActiveSuggestionIndex] = React.useState(0);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = toggle => isOpen => {
      setShowingSuggestions(isOpen);
      toggle(isOpen);
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const handleShowSuggestions = t0;
  let t1;
  if ($[1] !== activeSuggestionIndex || $[2] !== onChange || $[3] !== quickSelectOptions || $[4] !== showingSuggestions) {
    t1 = (event, toggle_0) => {
      if (event.key === "ArrowDown") {
        if (showingSuggestions) {
          setActiveSuggestionIndex(prev => (prev + 1) % Object.keys(quickSelectOptions).length);
        } else {
          handleShowSuggestions(toggle_0)(true);
        }
      } else {
        if (event.key === "ArrowUp") {
          setActiveSuggestionIndex(prev_0 => (prev_0 - 1 + Object.keys(quickSelectOptions).length) % Object.keys(quickSelectOptions).length);
        } else {
          if (event.key === "Enter") {
            event.preventDefault();
            onChange(getValueFromIndex(activeSuggestionIndex, quickSelectOptions));
            handleShowSuggestions(toggle_0)(false);
          } else {
            if (event.key === " ") {
              if (showingSuggestions) {
                onChange(getValueFromIndex(activeSuggestionIndex, quickSelectOptions));
                handleShowSuggestions(toggle_0)(false);
              } else {
                handleShowSuggestions(toggle_0)(true);
              }
            }
          }
        }
      }
    };
    $[1] = activeSuggestionIndex;
    $[2] = onChange;
    $[3] = quickSelectOptions;
    $[4] = showingSuggestions;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const handleKeyDown = t1;
  let t2;
  if ($[6] !== handleKeyDown || $[7] !== triggerComponent) {
    t2 = t3 => {
      const {
        toggle: toggle_1,
        triggerRef
      } = t3;
      return <div onFocus={() => handleShowSuggestions(toggle_1)(true)} onBlur={() => handleShowSuggestions(toggle_1)(false)} onKeyDown={event_0 => handleKeyDown(event_0, toggle_1)} ref={triggerRef}>{triggerComponent}</div>;
    };
    $[6] = handleKeyDown;
    $[7] = triggerComponent;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      borderRadius: 0,
      border: 0
    };
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== activeSuggestionIndex || $[11] !== onChange || $[12] !== quickSelectOptions) {
    t4 = t5 => {
      const {
        toggle: toggle_2
      } = t5;
      return <div className="border-steel-200 flex flex-col rounded-md border bg-white py-2"><div className={`${"py-2 pl-6 pr-12 text-base"} text-steel-400`}>Quick select</div>{Object.keys(quickSelectOptions).map((key, index) => {
          const isActive = index === activeSuggestionIndex;
          const className = cn(`${"py-2 pl-6 pr-12 text-base"} inline text-start`, {
            "bg-brand-400 text-white": isActive,
            "text-steel-500": !isActive
          });
          const setAsActive = () => setActiveSuggestionIndex(index);
          return <button className={className} key={key} onMouseOver={setAsActive} onFocus={setAsActive} onMouseDown={e => {
            e.stopPropagation();
            onChange(quickSelectOptions[key]);
            handleShowSuggestions(toggle_2)(false);
          }} type="button" tabIndex={-1}>{key}</button>;
        })}</div>;
    };
    $[10] = activeSuggestionIndex;
    $[11] = onChange;
    $[12] = quickSelectOptions;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== t2 || $[15] !== t4) {
    t5 = <UncontrolledPopper trigger={t2} style={t3}>{t4}</UncontrolledPopper>;
    $[14] = t2;
    $[15] = t4;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  return t5;
}